/**
 * Returns a data-story-element attribute for debugging/identification purposes.
 * Only renders in development mode — stripped from production builds.
 */
export function storyElement(name: string): Record<string, string> {
  if (import.meta.env.DEV) {
    return { "data-story-element": name };
  }
  return {};
}
